import { Group, Select } from '@mantine/core'
import { useForm } from '@mantine/form'
import { useGetPlaces } from 'hooks/places'
import { useEffect } from 'react'

type Props = {
  onPlaceSelect: (placeId?: string) => void
}

export default function PlaceSelect({ onPlaceSelect }: Props) {
  const { data: places } = useGetPlaces()

  const form = useForm()

  useEffect(() => {
    const rack = parseInt(form.values.rack)
    const column = parseInt(form.values.column)
    const shelf = parseInt(form.values.shelf)
    const place = places.find((place) => place.rack === rack && place.column === column && place.shelf === shelf)
    onPlaceSelect(place?.id)
  }, [form.values])

  useEffect(() => {
    form.setFieldValue('column', undefined)
  }, [form.values.rack])

  useEffect(() => {
    form.setFieldValue('shelf', undefined)
  }, [form.values.column])

  const racks = Array.from(new Set(places.map((place) => place.rack))).sort((a, b) => a - b)

  function getColumns(rack: string) {
    return Array.from(
      new Set(places.filter((place) => place.rack === parseInt(rack)).map((place) => place.column))
    ).sort((a, b) => a - b)
  }

  function getShelves(rack: string, column: string) {
    return Array.from(
      new Set(
        places
          .filter((place) => place.rack === parseInt(rack) && place.column === parseInt(column))
          .map((place) => place.shelf)
          .sort((a, b) => a - b)
      )
    )
  }

  function getSelectItems(values: Array<number>) {
    return values.map((value) => ({ value: value.toString(), label: value.toString() }))
  }

  return (
    <form>
      <Group>
        <Select
          label="Regał"
          data={getSelectItems(racks)}
          {...form.getInputProps('rack')}
          allowDeselect={false}
          maw={120}
        />
        <Select
          label="Kolumna"
          data={getSelectItems(getColumns(form.values.rack))}
          {...form.getInputProps('column')}
          disabled={!form.values.rack}
          allowDeselect={false}
          maw={120}
          key={`column_${form.values.rack}`}
        />
        <Select
          label="Półka"
          data={getSelectItems(getShelves(form.values.rack, form.values.column))}
          {...form.getInputProps('shelf')}
          disabled={!form.values.column}
          allowDeselect={false}
          maw={120}
          key={`shelve_${form.values.column}`}
        />
      </Group>
    </form>
  )
}
